import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Dumbbell, Users, Heart, Apple } from 'lucide-react';

const services = [
  {
    icon: Dumbbell,
    title: 'Personal Training',
    description: 'Get one-on-one guidance from certified trainers who design custom workout plans tailored to your goals and fitness level.',
    link: '/services'
  },
  {
    icon: Users,
    title: 'Group Classes',
    description: 'Join our high-energy group fitness classes including HIIT, yoga, spin, and strength training sessions.',
    link: '/services'
  },
  {
    icon: Apple,
    title: 'Nutrition Counseling',
    description: 'Work with our nutrition experts to develop meal plans that complement your training and help you achieve optimal results.',
    link: '/services'
  },
  {
    icon: Heart,
    title: 'Recovery & Wellness',
    description: 'Enhance your recovery with our sauna, massage therapy, and wellness programs designed for peak performance.',
    link: '/services'
  }
];

const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-black mb-4">Our Services</h2>
          <div className="w-24 h-1 bg-power-red mx-auto"></div>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-power-gray rounded-lg p-6 hover:shadow-lg transition-all duration-300 group hover:-translate-y-2"
            >
              <div className="bg-power-red rounded-full w-16 h-16 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <service.icon className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-black mb-4">{service.title}</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">{service.description}</p>
              <Link
                to={service.link}
                className="text-power-red font-semibold hover:text-red-700 transition-colors duration-300 inline-flex items-center"
              >
                Learn More →
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <Link
            to="/services"
            className="bg-power-red hover:bg-red-700 text-white font-bold py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg inline-block"
          >
            View All Services
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
